import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { locale as en } from '../config/i18n/en'
import { locale as tw } from '../config/i18n/tw'




Vue.use(VueI18n)

let messages = {}
messages = { en, tw } // 這邊把所有的翻譯文檔JS放進來

export default new VueI18n({
    locale: 'tw', // set locale (指定要讀哪一份譯文文檔)
    messages, // set locale messages
})


//////////////////
// WEBPACK FOOTER
// ./common/plugins/vue-i18n.js
// module id = null
// module chunks = 